import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import {
  AuthorizeContextValue,
  withAuthorizeContext,
} from 'pages/Authorize/AuthorizeContext';
import { getProviderFormLabel } from '../utils';

const SignInOnpayCredential = ({
  isLoading,
  onSubmit,
  provider,
}: RegisterImplementationProps & AuthorizeContextValue) => {
  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      onSubmit={onSubmit}
      fieldNames={['username', 'password']}
      render={({ username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="Username"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://app.onpay.com/app/forgot-password'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            <LoaderButton
              isLoading={isLoading}
              disabled={isLoading || !username.value || !password.value}
              type="submit"
              text="Connect"
            />
          </>
        );
      }}
    />
  );
};

export default withAuthorizeContext(SignInOnpayCredential);
